import { TermType } from '@/types/models'

export type TermPagePath =
  | 'activities'
  | 'amenities'
  | 'approach'
  | 'care'
  | 'clientele'
  | 'condition'
  | 'insurance'
  | 'price'
  | 'setting'
  | 'therapies'
  | 'languages'

export type TermPageMapping = Record<TermType, TermPagePath>

export type FacetPage = `Location+${TermType}`

export enum Page {
  HOME = 'Home',
  UTILITIES = 'Utilities',
  CENTER_PROFILE = 'CenterProfile',
  BRAND_PROFILE = 'BrandProfile',
  BROWSE = 'Browse',
  RESOURCES = 'Resources',
  LOCATION = 'Location',
  FACET_LOCATION = 'Location+',
  CONDITION = 'what_we_treat',
  CLIENTELE = 'who_we_treat',
  INSURANCE = 'accepted_insurance',
  THERAPY = 'treatment_therapy',
  THERAPIES = 'treatment_therapies',
  CARE = 'treatment_services',
  AMENITIES = 'amenities',
  ACTIVITY = 'activity',
  ACTIVITIES = 'activities',
  SETTING = 'setting',
  PRICE = 'price',
  APPROACH = 'treatment_method',
  APPROACHES = 'treatment_methods',
  SPECIAL_CONSIDERATION = 'special_consideration',
  SPECIAL_CONSIDERATIONS = 'special_considerations',
  LANGUAGE = 'language',
  LANGUAGES = 'languages',
  CAREERS = 'careers',
  FAVORITES = 'favorite',
  LISTS = 'lists'
}

export const TAXONOMY_PAGES: Page[] = [
  Page.CONDITION,
  Page.CLIENTELE,
  Page.INSURANCE,
  Page.THERAPY,
  Page.CARE,
  Page.AMENITIES,
  Page.ACTIVITIES,
  Page.ACTIVITY,
  Page.SETTING,
  Page.PRICE,
  Page.APPROACH,
  Page.SPECIAL_CONSIDERATION
]

export const TermPageType: TermPageMapping = {
  [Page.INSURANCE]: 'insurance',
  [Page.CONDITION]: 'condition',
  [Page.CLIENTELE]: 'clientele',
  [Page.APPROACH]: 'approach',
  [Page.THERAPY]: 'therapies',
  [Page.CARE]: 'care',
  [Page.AMENITIES]: 'amenities',
  [Page.ACTIVITY]: 'activities',
  [Page.SETTING]: 'setting',
  [Page.PRICE]: 'price',
  [Page.SPECIAL_CONSIDERATION]: 'amenities',
  [Page.SPECIAL_CONSIDERATIONS]: 'amenities',
  [Page.APPROACHES]: 'approach',
  [Page.ACTIVITIES]: 'activities',
  [Page.THERAPIES]: 'therapies',
  [Page.LANGUAGE]: 'languages',
  [Page.LANGUAGES]: 'languages'
}

export const FacetPageT = (type: TermType): FacetPage =>
  `Location+`.concat(type) as FacetPage

export type PageType = Page | FacetPage | ''
